export const PASSWORD_COMPLEXITY_REGEX = /^(?=.*[a-z])(?=.*[A-Z])(?=.*[\d\W_])/;
// eslint-disable-next-line max-len
export const STRONG_PASSWORD_COMPLEXITY_MESSAGE = 'Must include at least one uppercase, one lowercase, and one digit or special character';
export const STRONG_PASSWORD_LENGTH_MESSAGE = 'Must be at least 8 characters long';

type Options = {
  allErrors?: boolean;
};
export const strictPasswordValidationError = (
  password?: string, { allErrors = false }: Options = {},
) => {
  const errors = [];

  if ((password || '').length < 8) {
    errors.push(`Password ${STRONG_PASSWORD_LENGTH_MESSAGE.toLowerCase()}.`);
  }
  if (!PASSWORD_COMPLEXITY_REGEX.test(password)) {
    errors.push(`Password ${STRONG_PASSWORD_COMPLEXITY_MESSAGE.toLowerCase()}.`);
  }

  return allErrors ? errors : errors[0];
};
